<div class="dialog-header">
  <div class="header-content">
    <div class="header-icon">
      <mat-icon>draw</mat-icon>
    </div>
    <div class="header-text">
      <h2 mat-dialog-title>
        {{ 'createDoc.signatureDialog.title' | transloco }}
      </h2>
      <p class="header-subtitle">
        {{ 'createDoc.signatureDialog.subtitle' | transloco }}
      </p>
    </div>
  </div>
  <button mat-icon-button color="primary" (click)="onCancel()" type="button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="options-grid">
    <button type="button" class="option-card disabled"
      [disabled]="true"
      [class.selected]="withSignature"
      (click)="selectOption(true)">
      <div class="option-icon green">
        <mat-icon>verified</mat-icon>
      </div>
      <h3 class="option-title">
        {{ 'createDoc.signatureDialog.withSignatureTitle' | transloco }}
      </h3>
      <p class="option-description">
        {{ 'createDoc.signatureDialog.withSignatureDescription' | transloco }}
      </p>
    </button>

    <button type="button" class="option-card"
      [class.selected]="!withSignature"
      (click)="selectOption(false)">
      <div class="option-icon blue">
        <mat-icon>edit</mat-icon>
      </div>
      <h3 class="option-title">
        {{ 'createDoc.signatureDialog.withoutSignatureTitle' | transloco }}
      </h3>
      <p class="option-description">
        {{ 'createDoc.signatureDialog.withoutSignatureDescription' | transloco }}
      </p>
    </button>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button type="button" (click)="onCancel()">
    {{ 'common.buttons.cancel' | transloco }}
  </button>
  <button mat-raised-button color="primary" type="button" (click)="onCreate()">
    {{ 'createDoc.signatureDialog.createButton' | transloco }}
  </button>
</mat-dialog-actions>
